import { render, staticRenderFns } from "./Template31.vue?vue&type=template&id=f8f8d5b2&scoped=true&"
import script from "./Template31.vue?vue&type=script&lang=js&"
export * from "./Template31.vue?vue&type=script&lang=js&"
import style0 from "./Template31.vue?vue&type=style&index=0&id=f8f8d5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f8d5b2",
  null
  
)

export default component.exports